import ENV from "@/utils/env";
import { api } from "@/lib/api";
import { Session } from "@/api/auth/types/session.type";

/* Request Types */
interface CreateSessionReq {
  accountId: string;
  userId: string;
  idToken: string;
}

/* Response Types */
interface GetSessionResp {
  payload: {
    session: Session;
  };
}

/*
 * createSession endpoint
 *
 * Creates a new session and provides a cookie for authentication.
 */
export const createSession = async ({ accountId, userId, idToken }: CreateSessionReq) => {
  const resp = await api.post(
    `${ENV.API_PLATFORM_URL}/manage/sessions`,
    {
      accountId,
      userId,
    },
    { headers: { Authorization: `Bearer ${idToken}` } },
  );
  return resp.data as Session;
};

/*
 * deleteSession endpoint
 *
 * Deletes the current session and invalidates the cookie.
 */
export const deleteSession = async () => {
  const resp = await api.delete(`${ENV.API_PLATFORM_URL}/manage/sessions`);
  return resp.data;
};

/*
 * getSession endpoint
 *
 * Get the current session using a cookie for authentication.
 */
export const getSession = async () => {
  const resp = await api.get(`${ENV.API_PLATFORM_URL}/manage/sessions`);
  return resp.data as GetSessionResp;
};

/*
 * validateCode endpoint
 *
 * Validates the code from the Auth0 callback.
 *
 * Note: This is currently not used in the application due to us using v2 for authentication.
 */
export const validateCode = async (code: string) => {
  const resp = await api.post(`${ENV.API_PLATFORM_URL}/manage/auth0/exchange`, {
    accessCode: code,
    redirectUrl: ENV.AUTH0_CALLBACK_URL,
  });

  return resp.data;
};
